import React from 'react';

const LolTagIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect width="24" height="24" rx="12" fill="#C79B3B" fillOpacity="0.15" />
      <mask id="mask0_9182_16991" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="6" y="6" width="12" height="12">
        <path d="M18 6H6V18H18V6Z" fill="white" />
      </mask>
      <g mask="url(#mask0_9182_16991)">
        <path d="M6.72265 9.65625C6.26206 10.4388 6 11.3349 6 12.2879C6 13.2408 6.26206 14.1378 6.72265 14.9203V9.65625Z" fill="#C79B3B" />
        <path d="M12.0002 6.75781C11.5135 6.75781 11.0411 6.81296 10.5879 6.91305V7.78327C11.0367 7.66471 11.5099 7.59963 12.0002 7.59963C14.8091 7.59963 17.0864 9.69191 17.0864 12.2733C17.0864 13.4358 16.6232 14.4991 15.8588 15.3169L15.7138 15.7939L15.3929 16.8497C16.9676 15.8532 18.0011 14.182 18.0011 12.2888C18.0002 9.23336 15.3141 6.75781 12.0002 6.75781Z" fill="#C79B3B" />
        <path d="M10.5879 15.157H15.1899H15.2905C16.0694 14.407 16.5491 13.3915 16.5491 12.2731C16.5491 9.96461 14.5129 8.09375 12.0005 8.09375C11.5073 8.09375 11.0332 8.16737 10.5882 8.3V15.157H10.5879Z" fill="#C79B3B" />
        <path d="M10.0434 6H6.61987L7.26634 7.23695V16.7639L6.61987 18H14.4766L15.1893 15.659H10.0434V6Z" fill="#C79B3B" />
      </g>
    </svg>
  );
};

export default LolTagIcon;